import { jsx as _jsx } from "react/jsx-runtime";
import { BottomNavigation, BottomNavigationAction, Box, Badge, useTheme, useMediaQuery } from '@mui/material';
const BottomNav = ({ items, onItemClick, activeItem, backgroundColor, textColor, activeItemColor, activeItemBackgroundColor, className, sx, showOnMobile = true, showOnTablet = true }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'xl'));
    // Show on mobile and tablet, hide on desktop
    if ((!isMobile && !isTablet) || (isMobile && !showOnMobile) || (isTablet && !showOnTablet)) {
        return null;
    }
    const handleItemClick = (item) => {
        if (onItemClick) {
            onItemClick(item);
        }
        if (item.onClick) {
            item.onClick();
        }
    };
    const renderIcon = (item) => {
        if (!item.icon)
            return null;
        // Since we're now passing JSX elements directly, we can simplify this
        const iconElement = item.icon;
        if (item.badge) {
            return (_jsx(Badge, { badgeContent: item.badge, color: 'error', sx: {
                    '& .MuiBadge-badge': {
                        fontSize: '10px',
                        height: 16,
                        minWidth: 16
                    }
                }, children: iconElement }));
        }
        return iconElement;
    };
    return (_jsx(Box, { sx: {
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.appBar,
            backgroundColor: 'transparent',
            ...sx
        }, className: className, children: _jsx(BottomNavigation, { value: activeItem, onChange: (event, newValue) => {
                const item = items.find((item) => item.id === newValue);
                if (item) {
                    handleItemClick(item);
                }
            }, showLabels: false, sx: {
                backgroundColor: 'transparent',
                '& .MuiBottomNavigationAction-root': {
                    color: textColor || theme.palette.grey[400],
                    minWidth: 'auto',
                    padding: theme.spacing(1),
                    borderRadius: theme.spacing(1),
                    margin: theme.spacing(0.5),
                    transition: 'all 0.2s ease-in-out',
                    '&.Mui-selected': {
                        color: activeItemColor || theme.palette.common.white,
                        '& .MuiBottomNavigationAction-label': {
                            display: 'block',
                            fontSize: '10px',
                            fontWeight: 600,
                            marginTop: theme.spacing(0.5),
                            color: activeItemColor || theme.palette.common.white
                        }
                    },
                    '& .MuiBottomNavigationAction-label': {
                        display: 'none',
                        fontSize: '10px',
                        fontWeight: 500,
                        marginTop: theme.spacing(0.5)
                    },
                    '& .MuiSvgIcon-root': {
                        fontSize: '20px'
                    }
                }
            }, children: items.map((item) => (_jsx(BottomNavigationAction, { label: item.label, value: item.id, icon: renderIcon(item), sx: {
                    '&.Mui-selected': {
                        color: activeItemColor || theme.palette.common.white,
                        '& .MuiBottomNavigationAction-label': {
                            display: 'block',
                            color: activeItemColor || theme.palette.common.white
                        }
                    }
                } }, item.id))) }) }));
};
export default BottomNav;
